(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orea-cod-overrides"] && !Shopify.designMode) return;
  try {
    const setOreaStyle = (element, property, value) => {
  if (!element) return;
  if (element.style.getPropertyValue(property) !== value || element.style.getPropertyPriority(property) !== 'important') {
    element.style.setProperty(property, value, 'important');
  }
};

const styleEasySell = () => {
  const formButton = document.getElementById('es-form-button');
  setOreaStyle(formButton, 'background', '#171717');
  setOreaStyle(formButton, 'border-radius', '8px');
  setOreaStyle(formButton, 'box-shadow', 'none');

  const orderButton = document.getElementById('es-sticky');
  setOreaStyle(orderButton, 'background', '#171717');
  setOreaStyle(orderButton, 'border-radius', '8px');
};

styleEasySell();

new MutationObserver(styleEasySell).observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['style'],
  childList: true,
  subtree: true
});
  } catch(e) { console.error(e); }
})();

})();
